<template>
  <div>
    <router-link class="badge badge-warning" :to="{
      name: 'Common.OrderDetails',
      query: { id: relatedInfo.relatedEntityId2 }
    }" v-if="relatedInfo.relatedEntityType == 'StorefrontOrderShipment'">Storefront Shipment:  {{ relatedInfo.referenceNumber }}</router-link>
    <router-link class="badge badge-success" :to="{
      name: 'Common.OrderDetails',
      query: { id: relatedInfo.relatedEntityId }
    }" v-else-if="relatedInfo.relatedEntityType == 'StorefrontOrder'">Storefront Order: {{ relatedInfo.referenceNumber }}</router-link>
    <router-link class="badge badge-primary" :to="{
        name: 'Warehouses.BulkShipments.View',
        params: { id: relatedInfo.relatedEntityId }
    }" v-else-if="relatedInfo.relatedEntityType == 'BulkShipment'">Bulk Shipment: {{ relatedInfo.referenceNumber }}</router-link>
    <router-link class="badge badge-dark" :to="{
        name: 'Warehouses.ManualShipments.Edit',
        params: { id: relatedInfo.relatedEntityId }
    }" v-else-if="relatedInfo.relatedEntityType == 'SmallParcelShipment'">Small Parcel Shipment: {{ relatedInfo.referenceNumber }}</router-link>
    <span class="badge badge-dark" v-else-if="relatedInfo.relatedEntityType == 'NotTrackedExtensivOrder'">Other Order: {{ relatedInfo.referenceNumber }}</span>
    <span class="badge badge-secondary" v-else>Unknown</span>
  </div>
</template>

<script>
export default {
  props: {
    relatedInfo: {
      required: true
    }
  }
}
</script>

<style>

</style>
